// v281 — Ticket row/card click helpers.
//
// Rows/cards use plain <tr>/<div> for layout reasons (a <tr> can't be wrapped
// in a <Link>, and Kanban cards are draggable + have nested interactive
// elements). This helper preserves the current same-tab click behaviour and
// adds native "open in new tab" support for:
//   • Ctrl+click / Cmd+click  → new background tab (matches every browser)
//   • Middle-click (mouse wheel)  → new background tab (via `onAuxClick`)
//
// Right-click « Ouvrir dans un nouvel onglet » requires an actual <a> element
// under the cursor — see the small <Link> wrapping the ticket #number in
// Tickets.jsx / Kanban.jsx / CallsBoard.jsx for that path.

export function openTicketFromEvent(e, url, nav) {
  // Ignore clicks that originated inside a nested link/button (they have
  // their own default behaviour and shouldn't trigger row navigation twice).
  if (e.defaultPrevented) return;
  const t = e.target;
  if (t && typeof t.closest === "function" && t.closest("a,button,input,[data-row-checkbox]")) {
    return;
  }
  const isMiddle = e.button === 1 || e.type === "auxclick";
  const isModifier = e.ctrlKey || e.metaKey;
  if (isMiddle || isModifier) {
    e.preventDefault();
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  }
  // Only left-clicks in the same tab.
  if (e.type === "click" && e.button === 0) {
    nav(url);
  }
}
